import { Badge } from '@folio/components';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { useTranslation } from 'react-i18next';
import { CreateConfirmDerogationButton } from './buttons/CreateConfirmDerogationButton';
import { CreateQuoteDerogationButton } from './buttons/CreateQuoteDerogationButton';
import { PhygitalSignatureButton } from './buttons/PhygitalSignatureButton';
import { PushCustomEventButton } from './buttons/PushCustomEventButton';
import { QuicksignButton } from './buttons/QuicksignButton';
import { SendInSignatureButton } from './buttons/SendInSignatureButton';
import { useVisibilityConditionsProps } from './useVisibilityConditionsProps';
import { Group } from '@folio/components/ui/flex';

export function FinalizeNewBusinessActions({ overridenBranchId }: { overridenBranchId?: string }) {
  const { t } = useTranslation();

  const { policy } = usePolicyOnDashboard();

  const visibilityConditionsProps = useVisibilityConditionsProps({
    action: 'CONFIRM',
    overridenBranchId,
  });

  const isQuicksignEnabled = ['axeceVtc', 'axeceMultiRisquesPro'].includes(policy.productId);
  const isPushCustomEventEnabled = ['axeceVtc', 'axeceMultiRisquesPro'].includes(policy.productId);
  const isFaceToFaceSignatureEnabled = ['axeceVtc', 'axeceMultiRisquesPro'].includes(
    policy.productId,
  );

  const isContractSent =
    visibilityConditionsProps?.policyStatus === 'POLICY_CONFIRMED' &&
    visibilityConditionsProps.isDerogationSatisfied;

  return isContractSent ? (
    <Group gap={2}>
      <Badge variant="outline">{t('finalizeNewBusiness.contractSentBadge')}</Badge>
      <CreateQuoteDerogationButton overridenBranchId={overridenBranchId} />
      <CreateConfirmDerogationButton overridenBranchId={overridenBranchId} />
    </Group>
  ) : (
    <Group gap={2}>
      <SendInSignatureButton />
      {isPushCustomEventEnabled && <PushCustomEventButton overridenBranchId={overridenBranchId} />}
      {isQuicksignEnabled && <QuicksignButton overridenBranchId={overridenBranchId} />}
      {isFaceToFaceSignatureEnabled && (
        <PhygitalSignatureButton overridenBranchId={overridenBranchId} />
      )}
      <CreateQuoteDerogationButton overridenBranchId={overridenBranchId} />
      <CreateConfirmDerogationButton overridenBranchId={overridenBranchId} />
    </Group>
  );
}
